import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { DialogBody, DialogCloseButton, DialogFooter } from '@gitbook/spine-react';

import { FilesManager } from '../Files';
import type { InsertFilesAccept } from './state';

/**
 * Tab to select a file from the space
 */
export function TabFiles(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
    accept: InsertFilesAccept;
    onSelect: (urls: api.ContentRefFile[]) => void;
}): React.ReactElement {
    const { space, changeRequest, accept, onSelect } = props;

    return (
        <div className="max-h-[55vh] overflow-y-auto">
            <DialogBody>
                <FilesManager
                    space={space}
                    changeRequest={changeRequest}
                    accept={accept}
                    onSelect={onSelect}
                    mode={accept === 'images' || accept === 'drawings' ? 'grid' : 'list'}
                />
            </DialogBody>
            <DialogFooter>
                <DialogCloseButton />
            </DialogFooter>
        </div>
    );
}
